import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../core/services/base-crud.service';

@Injectable({
  providedIn: 'root',
})
export class SupportInformationService extends BaseCrudService<any, any> {
  
}
